const CONFIG = {
    BACKEND_URL: "https://flockfrenzyserver.up.railway.app/",
    // BACKEND_URL: "http://localhost:9000",

    WEBSOCKET_URL: 'https://flockfrenzywebsocket.up.railway.app/',
}

export default CONFIG;